"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Отображается в откликах, списке резюме, резюме и поиске */
const careerBannerClick = ({ searchProfession, resumeProfession, resumeHash, ...analyticsParams } = {}) => analytics_js_1.default.sendHHEventButtonClick("career_banner", { searchProfession, resumeProfession, resumeHash, ...analyticsParams });
exports.default = careerBannerClick;
